<template>
  <v-container> 
    <v-row dense class="mt-3">
      <v-col cols="12" sm="6">
        <v-select
          label="Категория работ"
          v-model="category"
          :items="servicesCategories"
          filled
          clearable
          dense
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <v-select
          label="Этап работ"
          v-model="stage"
          :items="stages"
          filled
          clearable
          dense
        ></v-select>
      </v-col>
    </v-row>

    <v-data-table
      class="elevation-1"
      :headers="tableHeaders"
      :items="items"
      disable-pagination
      hide-default-footer
      :search="search"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0 ml-2 mr-2">
          <v-col cols="10" sm="8">
            <v-text-field
              placeholder="Введите данные для поиска"
              v-model="search"
            ></v-text-field>
          </v-col>
          <v-col cols="2" sm="4" class="d-flex pt-5" v-if="!isPartner">
            <v-spacer></v-spacer>
            <service-card></service-card>
          </v-col>
        </v-row>
      </template>

      <template v-if="items.length > 0" v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item._id">
            <td v-if="!isPartner">
              <up-down-elem
                :upFunc="'prices/' + (item.itemType == 'service' ? 'UP_SERVICE' : 'UP_SERVICES_BLOCK')"
                :downFunc="'prices/' + (item.itemType == 'service' ? 'DOWN_SERVICE' : 'DOWN_SERVICES_BLOCK')"
                :id="item.itemType == 'service' ? item.service._id : { category: item.category, subCategory: item.subCategory }"
              ></up-down-elem>
            </td>
            <td>{{ item.stageIndex }}</td>
            <td :colspan="item.itemType == 'service' ? 1 : 3">
              <template v-if="item.itemType == 'service'">
                {{ item.service.name }}
                <template v-if="item.solution">
                  <v-menu>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" icon>
                        <v-icon small>mdi-information-outline</v-icon>
                      </v-btn>
                    </template>

                    <v-card>
                      <v-card-text>
                        <span>{{item.solution.name}}</span>
                        <ul
                          v-if="item.solution.textPoints.length > 0"
                        >
                          <li 
                            v-for="pnt of item.solution.textPoints"
                            :key="item.solution._id + pnt"
                          >{{pnt}}</li>
                        </ul>
                        <div>
                          <strong style="font-style: italic;">
                            Укажите минимальную стоимость (цена-от) за {{ item.service.unitName }}.
                          </strong>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                </template>
              </template>
              <template v-if="item.itemType == 'subCategory'"><strong>{{ item.subCategory }}</strong></template>
              <template v-if="item.itemType == 'category'"><strong>{{ item.category.toUpperCase() }}</strong></template>
            </td>
            <td v-if="item.itemType == 'service'">
              {{ item.service.unitName }}
            </td>
            <td v-if="item.itemType == 'service'">
              <number-field
                :value="item.service.pricePerUnit"
                :accuracy="2"
                @changed="$store.commit('prices/UPDATE_SERVICE_PRICE', { id: item.service._id, newPrice: $event })"
              ></number-field>
            </td>
            <td v-if="!isPartner">
              <template v-if="item.itemType == 'service'">
                <service-card :id="item.service._id"></service-card>
                <delete-button
                  :id="item.service._id"
                  :deleteFunc="deleteService"
                  objName="работу"
                >
                  Название: {{ item.service.name }}
                </delete-button>
              </template>
              <service-card
                v-else
                :category="item.category"
                :subCategory="item.subCategory"
              ></service-card>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
   
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { getTempId } from '../../models/common';
import ServiceCard from './ServiceCard';
import axios from 'axios';
import csv from 'csv-parser';
import fs from 'fs';

export default {
  name: 'services',

  components: {
    ServiceCard
  },

  data() {
    let tableHeaders = [
      {
        text: '',
        value: 'updown',
        sortable: false
      },
      {
        text: 'Этап',
        value: 'stageIndex'
      },
      {
        text: 'Наименование',
        value: 'name'
      },
      {
        text: 'Ед. изм.',
        value: 'unitName'
      },
      {
        text: 'Цена за ед.',
        value: 'costPerUnit'
      },
      {
        text: 'Действия',
        value: 'actions'
      }
    ];
    return {
      redirectCount: 0,
      category: null,
      stage: null,
      search: '',
      tableHeaders: this.$store.getters['users/isPartner'] ? tableHeaders.slice(1, 5) : tableHeaders
    }
  },

  methods: {
    async deleteService(id) {
      this.$store.commit('prices/DELETE_SERVICE', id);
    },
    /*async loadPrice() {
      let price = (await axios.get('/api/prices/dev-price')).data;
      price.forEach(element => {
        this.$store.commit('prices/CREATE_SERVICE', element);
      });
    }*/
    findSolution(serviceName) {
      let res = serviceName.match(/Пакет услуг "(.*)"$/);
      if (res) {
        let sol = this.solutions.find(x => x.name == res[1]);
        return sol;
      }
      return null;
    }
  },

  computed: {
    ...mapGetters('prices', ['servicesCategories', 'stages']),
    ...mapGetters('users', ['isPartner']),
    solutions() {
      return this.$store.state.sites.entities.solution;
    },
    items() {
      this.redirectCount = 0;
      let items = [];
      let structure = this.$store.getters['prices/servicesStructure'](this.category, this.stage);
      //console.log(JSON.stringify(structure));
      for (let category of structure) {
        items.push({
          itemType: 'category',
          category: category.name,
          subCategory: '',
          _id: category.name
        });
        for (let subCategory of category.subCategories) {
          items.push({
            itemType: 'subCategory',
            category: category.name,
            subCategory: subCategory.name,
            _id: category.name + subCategory.name
          });
          items.push(...subCategory.services.map(item => ({
            itemType: 'service',
            service: item,
            _id: item._id,
            stageIndex: this.stages.findIndex(x => x.value == item.stages[0]),
            solution: this.findSolution(item.name)
          })));
          subCategory.services.forEach(elem => {
            this.redirectCount += elem.redirectTable.length
          });
        }
      }
      return items;
    }
  }
  
}
</script>